import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/gatsby';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  /* eslint-disable no-unused-vars */
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className='bg-base-200 p-10 text-center'>
          <h2 className='mt-0'>Something went wrong.</h2>
          <p className='mb-0'>Try refreshing your page.</p>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;
